const { ExtendedAuthorizationEndpointNotSecureApi, Configuration } =
    await import('remotes/@api/authorization_v4');

/**
 * @description ServiceResponseData.
 */
export class ServiceResponseData<Data = never> {
    data: Data;

    result?: Result;

    headers?: { [key: string]: string };

    /**
     * @description Constructor of {@link ServiceResponseData}.
     * @param {any} data - Data from response.
     * @param {Result} result - Technical data from response.
     * @param {Headers} headers - Headers.
     */
    constructor(
        data: Data,
        result?: Result,
        headers?: { [key: string]: string },
    ) {
        this.data = data;
        this.result = result;
        this.headers = headers;
    }
}

interface Result {
    readonly timestamp?: Date;
    status: number;
    code: string;
    message: string;
}

/**
 *
 */
export interface InfoMethodResponse {
    /**
     * ProposePIN.
     */
    proposePIN: boolean;
    /**
     * SessionExpired.
     */
    sessionExpired: boolean;
    /**
     * IsHasBiometricRegistration.
     */
    isHasBiometricRegistration: boolean;
    /**
     * UserName.
     */
    userName: string;
}

/**
 * @description Api info authorize.
 * @returns {Promise<InfoMethodResponse>} Return response of info method.
 */
export async function infoMethod(): Promise<
    ServiceResponseData<InfoMethodResponse>
> {
    const config = new Configuration();
    const api = new ExtendedAuthorizationEndpointNotSecureApi(config);
    const response = await api.authorizationInformationGET();
    const { data, result, headers } = response;
    const {
        proposePIN = false,
        sessionExpired = false,
        firstName,
        proposeAuthenticator = false,
        middleName,
    } = data || {};
    return {
        result,
        headers,
        data: {
            proposePIN,
            sessionExpired,
            isHasBiometricRegistration: proposeAuthenticator,
            userName: `${firstName} ${middleName}`,
        },
    };
}
